import React                                                                 from 'react';
import { Button, ButtonProps, Dropdown, DropdownProps, Icon, SemanticICONS } from "semantic-ui-react";
import { CorvalColor, SemanticUIColor, SemanticUISize }                      from "@src/types";
import { Cell, Grid }                                                        from "styled-css-grid";
import classNames                                                            from "classnames";
import { runIfFunction }                                                     from "@src/util";


interface IconMenuProps {
    value: SemanticICONS,
    iconOptions: SemanticICONS[],
    gridSize: number,
    cellWidth: number,
    valueColor?: CorvalColor,
    activeColor?: CorvalColor,
    inactiveColor?: CorvalColor,
    triggerButtonProps?: ButtonProps,
    dropdownProps?: Partial<DropdownProps>

    onClick( value: SemanticICONS ): void,
}

const IconMenuDefaultProps = {
    value:              'tag',
    iconOptions:        [],
    gridSize:           3,
    cellWidth:          50,
    valueColor:         null,
    activeColor:        SemanticUIColor.PURPLE,
    inactiveColor:      SemanticUIColor.GREY,
    triggerButtonProps: {},
    dropdownProps:      {},
    onClick:            null,
} satisfies Partial<IconMenuProps>;

function IconMenu( _props: IconMenuProps ){

    const props = { ...IconMenuDefaultProps, ..._props };

    const { gridSize, cellWidth } = props;

    const handleOnClick = ( value: SemanticICONS ) => {

        runIfFunction( props.onClick, value );
    };

    const iconOptions = ( props.iconOptions as SemanticICONS[] );

    return (
        <Dropdown
            icon={ null }
            trigger={
                <Button type={ 'button' } icon basic { ...props.triggerButtonProps }>
                    <Icon size={ SemanticUISize.LARGE }
                          color={ props.valueColor ?? SemanticUIColor.PURPLE }
                          name={ props.value as SemanticICONS }
                          fitted={ true }
                    />
                </Button>
            }
            { ...props.dropdownProps }>

            <Dropdown.Menu className={ 'overflow--y-auto' }>

                <Grid columns={ `repeat(${ gridSize }, ${ cellWidth }px)` }
                      rows={ `repeat(${ Math.ceil( iconOptions.length / gridSize ) }, ${ cellWidth }px)` }
                      className={ 'padding-xs' }
                      style={ { boxSizing: 'content-box' } }
                      gap={ `5px` }>

                    { iconOptions.map( ( templateIcon, index ) => {

                        const isActive = templateIcon === props.value;

                        return (

                            <Cell middle center key={ templateIcon }
                                  onClick={ () => handleOnClick( templateIcon ) }
                                  className={ classNames( {
                                      'cursor--pointer':                               !isActive,
                                      'outline-sm':                                    true,
                                      'outline--hover':                                !isActive,
                                      [ `outline--colored-${ props.activeColor }` ]:   isActive,
                                      [ `outline--colored-${ props.inactiveColor }` ]: !isActive,
                                  } ) }>

                                <Icon size={ SemanticUISize.LARGE }
                                      color={ (isActive ? props.activeColor : props.inactiveColor) as any }
                                      name={ templateIcon }
                                      fitted={ true }
                                />

                            </Cell>
                        );
                    } )
                    }
                </Grid>

            </Dropdown.Menu>
        </Dropdown>
    );
}

export {
    IconMenu,
    IconMenuDefaultProps,
    type IconMenuProps,
};
